import React, { useEffect, useState } from 'react';
import { Stack, TextField, MenuItem as MuiMenuItem, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import adminService from '../../services/adminService';

function SubmitRequestForm({ onSubmitted, submitting, onSubmit }) {
    const { user } = useAuth();
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('');
    const [companies, setCompanies] = useState([]);
    const [companyId, setCompanyId] = useState('');

    const isAdmin = user?.role === 'admin';

    useEffect(() => {
        if (!isAdmin) return;
        (async () => {
            try {
                const res = await adminService.getCompanies();
                const list = res.data?.data?.companies || [];
                setCompanies(list);
                if (list.length && !companyId) setCompanyId(list[0]._id);
            } catch (_) {}
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAdmin]);

    const handleSubmit = async () => {
        const payload = { title, description, category };
        if (user?.company?._id) {
            payload.company = user.company._id;
        } else if (user?.company) {
            payload.company = user.company; // may already be an id
        } else if (isAdmin && companyId) {
            payload.company = companyId;
        }
        await onSubmit(payload);
        setTitle('');
        setDescription('');
        setCategory('');
        setCompanyId('');
        onSubmitted?.();
    };

    return (
        <Stack spacing={2}>
            <TextField label="Title" value={title} onChange={(e) => setTitle(e.target.value)} size="small" />
            <TextField label="Description" value={description} onChange={(e) => setDescription(e.target.value)} multiline minRows={4} />
            {isAdmin && (
                <FormControl size="small" sx={{ minWidth: 240 }}>
                    <InputLabel id="company-label">Company</InputLabel>
                    <Select labelId="company-label" label="Company" value={companyId} onChange={(e) => setCompanyId(e.target.value)}>
                        {companies.map((c) => (
                            <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
            <TextField select size="small" label="Category" value={category} onChange={(e) => setCategory(e.target.value)} sx={{ minWidth: 200 }}>
                <MuiMenuItem value="">
                    <em>Uncategorized</em>
                </MuiMenuItem>
                <MuiMenuItem value="ui">UI</MuiMenuItem>
                <MuiMenuItem value="reporting">Reporting</MuiMenuItem>
                <MuiMenuItem value="integrations">Integrations</MuiMenuItem>
            </TextField>
            <Stack direction="row" spacing={1}>
                <Button variant="contained" onClick={handleSubmit} disabled={submitting || !title || !description}>Submit</Button>
                <Button variant="text" onClick={() => { setTitle(''); setDescription(''); setCategory(''); }}>Reset</Button>
            </Stack>
        </Stack>
    );
}

export default SubmitRequestForm;


